import enterpriseApi from '@/api/enterprise.api'

export const enterpriseService = (function () {
  'use strict'

  /**
   * Devuelve un arreglo de empresas para los selectores que se usan en los ABM
   */
  async function getAllForSelector() {
    try {
      const response = await enterpriseApi.getAllForSelector()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve un arreglo de empresas para el selector de empresas del ABM de usuarios
   */
  async function getAllForSelectorUserABM(enterpriseIds) {
    try {
      const response = await enterpriseApi.getAllForSelectorUserABM(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve un arreglo de empresas para el filtro del reporte de infracciones descartadas
   */
  async function getAllForFilter() {
    try {
      const response = await enterpriseApi.getAllForSelector()
      return response.data.map(enterprise => ({ id: enterprise._id, name: enterprise.name }))
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve los datos para la tabla del ABM de empresas
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   */
  async function findAll(pageSize, pageNumber, headers = false) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await enterpriseApi.findAll(pageSize, pageNumber, headers)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await enterpriseApi.findAll(undefined, undefined, headers)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de empresas de la collection para el paginador de la tabla del ABM
   */
  async function getTotal() {
    try {
      const response = await enterpriseApi.getTotal()
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve los datos de una empresa a partir de su id, para la actualización
   * @param {*} enterpriseId
   */
  async function findOne(enterpriseId) {
    try {
      const response = await enterpriseApi.findOne(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para eliminar una empresa
   */
  async function deleteOne(id) {
    try {
      const response = await enterpriseApi.deleteOne(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    try {
      const response = await enterpriseApi.deleteMany(ids)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }


  /**
   * Crea una nueva cosa en la collection
   * @param {*} enterprise
   */
  async function create(enterprise) {
    /*
    try {
      const response = await enterpriseApi.create(enterprise)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await enterpriseApi.create(enterprise)
    return response.data
  }

  /**
   * Actualiza una cosa existente en la collection
   * @param {*} enterprise
   */
  async function update(enterprise) {
    /*
    try {
      const response = await enterpriseApi.update(enterprise)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await enterpriseApi.update(enterprise)
    return response.data
  }

  /**
   * Para validar el nombre de una empresa
   * @param {*} name
   */
  async function validateName(name) {
    try {
      if (name) {
        const response = await enterpriseApi.validateName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Obtener un arreglo de privilegios para la configuración de los headers dinámicos en el ABM de Empresa
   */
  async function getRoutesPrivileges() {
    try {
      const response = await enterpriseApi.getRoutesPrivileges()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Crear una nueva empresa a partir de clonar otra 
   */
  async function clone({ cloneId, name }) {
    const response = await enterpriseApi.clone({ cloneId, name })
    return response.data
  }

  async function getUsersByEnterpriseId(id) {
    let result = await enterpriseApi.getUsersByEnterpriseId(id);
    return result.data;
  }

  async function getUsersWithoutEnterprise() {
    let result = await enterpriseApi.getUsersWithoutEnterprise();
    return result.data;
  }

  function filterUserList(userList, userIdList) {
    const result = [];
    userIdList.forEach((userId) => {
      userList.forEach((user) => {
        if (user.id === userId) {
          result.push({
            id: user.id,
            username: user.name
          });
        }
      });
    });
    return result;
  }

  /**
   * Inserta una imagen de fondo correspondiente a un enterprise en la collection
   * Se usa este endpoint para no sobrecargar al crear o actualizar un enterprise
   */
  async function saveImage(enterpriseName, enterpriseImage) {
    const response = await enterpriseApi.saveImage(enterpriseName, enterpriseImage)
    return response
  }

  return {
    getAllForSelector,
    getAllForFilter,
    findAll,
    getTotal,
    findOne,
    deleteOne,
    deleteMany,
    create,
    update,
    validateName,
    getRoutesPrivileges,
    clone,
    getUsersByEnterpriseId,
    getUsersWithoutEnterprise,
    filterUserList,
    getAllForSelectorUserABM,
    saveImage
  }
})()
